import { render, staticRenderFns } from "./add_administrator.vue?vue&type=template&id=39526f1c&scoped=true&"
import script from "./add_administrator.vue?vue&type=script&lang=js&"
export * from "./add_administrator.vue?vue&type=script&lang=js&"
import style0 from "./add_administrator.vue?vue&type=style&index=0&id=39526f1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39526f1c",
  null
  
)

export default component.exports